/**
 * @prop --track-color: The color of the spinner's track.
 * @prop --indicator-color: The color of the spinner's indicator.
 * @prop --stroke-width: The width of the indicator.
 */
:host {
  position: relative;
  box-sizing: border-box;

  & *,
  & *:before,
  & *:after {
    box-sizing: inherit;
  }

  --track-color: #0d131e20;
  --indicator-color: var(--plyr-color-main);
  --stroke-width: 2px;

  display: inline-flex;
}

.spinner {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: solid var(--stroke-width) var(--track-color);
  border-top-color: var(--indicator-color);
  border-right-color: var(--indicator-color);
  animation: 1s linear infinite spin;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
